<template>
<div>
  <v-layout row wrap justify-center>
    <ui-title-red textTitle="Calculadora de patrimonio"></ui-title-red>
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc  :vidTittle="'Activos'" videoEmbed="ADMINISTRACIONDINERO51Activos.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex xs12 mt-4>
      <p>
        Lo primero es saber a cuanto ascienden sus activos. Diligencie el siguiente formato y revíselo periódicamente.

      </p>
      <p>
        Importante: Digite las cifras sin puntos ni comas.
      </p>
    </v-flex>
  </v-layout>
  <v-layout row wrap>
    <ui-calculadora-patri :formulario="patrimonioActivo" nombresCols="Activos"></ui-calculadora-patri>
  </v-layout>
</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  computed: {
    patrimonioActivo() {
      return this.$store.state.patrimonioActivo;
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-51.vue?14c28537